export default {
	MAILHOUSES: 'companies/:company_id/mailhouses',
}